import React, { useState, useEffect } from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Box,
  Grid,
  IconButton,
  Container,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Header from "../../components/Header/userHeader";
import { UserFooter } from "../../components";
import ScrollToTopButton from "../../components/ScrollToTop";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { buildShopPath } from "../../utils/functionalOperations";
import { useFetch } from "../../hooks";

const ShopCard = ({ shop }) => {
  const navigate = useNavigate();
  const latitude = useSelector(
    (state) => state.user?.userLocation?.latitude ?? null,
  );
  const longitude = useSelector(
    (state) => state.user.userLocation?.longitude ?? null,
  );
  const [vendors, setVendors] = useState([]);
  const apptoken = useSelector((state) => state.user.apptoken);

  useEffect(() => {
    if (apptoken) {
      fetchData();
    }
  }, [apptoken, latitude, latitude]);

  const vendorUrl =
    latitude && longitude
      ? `${BASE_URL_TEST}/api/main/vendors?lat=${latitude}&lng=${longitude}&radius=20&vtype=regular`
      : null;

  const {
    data: vendorData,
    isLoading: isVendorsLoading,
    error,
    fetchData,
  } = useFetch(vendorUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });
  useEffect(() => {
    if (vendorData && vendorData.vendors) {
      const formattedVendors = vendorData.vendors.map((item) => ({
        id: item.id,
        name: item.name,
        shopName: item.shop_name,
        description:
          Array.isArray(item.categories) && item.categories.length > 0
            ? item.categories.map((c) => c.description).join(", ")
            : Array.isArray(item.listCategories) &&
                item.listCategories.length > 0
              ? item.listCategories.map((c) => c.description).join(", ")
              : "",
        image: item.store_image,
        distance: item.distance ? `${item.distance} km from you` : "N/A",
        rating: "4.8" || "N/A",
        regularListType: item.reg_list_type,
      }));
      setVendors(formattedVendors);
    }
  }, [vendorData]);

  const handleShopNow = () => {
    navigate(buildShopPath(shop), { state: { shop } });
  };

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        boxShadow: 3,
        borderRadius: 2,
        position: "relative",
        overflow: "hidden", // Ensures content doesn't overflow
      }}
    >
      {/* Rating badge */}
      <Box
        sx={{
          position: "absolute",
          top: 16,
          right: 16,
          padding: "4px 8px",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          zIndex: 1,
          backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent background
        }}
      >
        <StarIcon sx={{ color: "#FFA500", fontSize: 18 }} />
        <Typography
          variant="body2"
          sx={{ marginLeft: 0.5, color: "#FFA500", fontWeight: "bold" }}
        >
          {shop.rating}
        </Typography>
      </Box>

      {/* Shop image */}
      <CardMedia
        component="img"
        sx={{
          width: "100%",
          height: 180,
          objectFit: "cover",
        }}
        image={shop.image}
        alt={shop.name}
      />

      {/* Shop details */}
      <CardContent
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          padding: 2,
        }}
      >
        <Typography variant="h6" component="div" gutterBottom>
          {shop.shopName}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            display: "inline-block",
            padding: "4px 8px",
            borderRadius: "4px",
            marginBottom: 1.5,
            backgroundColor: "#FFF4E5",
            color: "#FF6F00",
          }}
        >
          {shop.description}
        </Typography>

        <Box sx={{ mt: "auto" }}>
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              alignItems: "center",
              marginBottom: 2,
            }}
          >
            <LocationOnIcon
              fontSize="small"
              sx={{ color: "#FF6F00", marginRight: 0.5 }}
            />
            {shop.distance}
          </Typography>

          {/* <Typography
            variant="body2"
            sx={{
              color: "#007BFF",
              marginBottom: 2,
            }}
          >
            Distance: Dynamic
          </Typography> */}

          {/* Shop now button */}
          <Button
            variant="contained"
            fullWidth
            sx={{
              backgroundColor: "#FF6F00",
              color: "#fff",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#E65C00",
              },
              marginTop: 1,
            }}
            size="medium"
            onClick={handleShopNow}
          >
            Shop Now
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

const SeeallnearbyShopsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleShopsCount = 4;
  const shopsPerRow = 2;
  const latitude = useSelector(
    (state) => state.user?.userLocation?.latitude ?? null,
  );
  const longitude = useSelector(
    (state) => state.user.userLocation?.longitude ?? null,
  );
  const [vendors, setVendors] = useState([]);
  const apptoken = useSelector((state) => state.user.apptoken);

  useEffect(() => {
    if (apptoken) {
      fetchData();
    }
  }, []);

  const vendorUrl =
    latitude && longitude
      ? `${BASE_URL_TEST}/api/main/vendors?lat=${latitude}&lng=${longitude}&radius=20&vtype=regular`
      : null;

  const {
    data: vendorData,
    isLoading: isVendorsLoading,
    error,
    fetchData,
  } = useFetch(vendorUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });
  useEffect(() => {
    if (vendorData && vendorData.vendors) {
      const formattedVendors = vendorData.vendors.map((item) => ({
        id: item.id,
        name: item.name,
        shopName: item.shop_name,
        description:
          Array.isArray(item.categories) && item.categories.length > 0
            ? item.categories.map((c) => c.description).join(", ")
            : Array.isArray(item.listCategories) &&
                item.listCategories.length > 0
              ? item.listCategories.map((c) => c.description).join(", ")
              : "",
        image: item.store_image,
        distance: item.distance
          ? `${item.distance} kms near to your Location`
          : "N/A",
        rating: "4.8" || "N/A",
        address: `${item.street}, ${item.city}, ${item.state}, ${item.country}, ${item.pincode}`,
        openTime: item.open_time,
        closeTime: item.close_time,
        latitude: item.latitude,
        longitude: item.longitude,
        phoneNumber: item.phone_number,
        regularListType: item.reg_list_type,
      }));
      setVendors(formattedVendors);
    }
  }, [vendorData]);

  // const visibleShops = vendors.slice(
  //   currentIndex,
  //   currentIndex + visibleShopsCount
  // );
  const visibleShops = vendors.slice(currentIndex);

  const handleNextPage = () => {
    if (currentIndex + visibleShopsCount < vendors.length) {
      setCurrentIndex(currentIndex + shopsPerRow);
    }
  };

  const handlePrevPage = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - shopsPerRow);
    }
  };

  return (
    <>
      <Header />
      <Container
        maxWidth="xl"
        sx={{
          my: 4,
          px: { xs: 1.5, sm: 2, md: 3 },
          width: "100%",
          maxWidth: "100%",
          overflowX: "hidden",
          boxSizing: "border-box",
        }}
      >
        {/* Section header */}
        <Box sx={{ textAlign: "left", width: "100%" }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              marginBottom: 3,
              ml: 3,
              color: "#2D3748",
              fontSize: {
                xs: "1rem",
                sm: "1.5rem",
                md: "1.75rem",
                lg: "1,75rem",
              },
              position: "relative",
              paddingBottom: 1.5,
              "&:after": {
                content: '""',
                position: "absolute",
                left: 0,
                bottom: 0,
                height: "4px",
                width: "60px",
                background: "linear-gradient(90deg, #6366F1 0%, #8B5CF6 100%)",
                borderRadius: "2px",
              },
            }}
          >
            Near By Shops
          </Typography>

          {/* Navigation controls */}
          {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <IconButton
              disabled={currentIndex === 0}
              onClick={handlePrevPage}
              sx={{
                color: currentIndex === 0 ? "grey.400" : "#FF6F00",
                backgroundColor: "white",
                boxShadow: 1,
              }}
            >
              <ArrowBackIosIcon fontSize="small" />
            </IconButton>
            <IconButton
              disabled={currentIndex + visibleShopsCount >= shopData.length}
              onClick={handleNextPage}
              sx={{
                color:
                  currentIndex + visibleShopsCount >= shopData.length
                    ? "grey.400"
                    : "#FF6F00",
                backgroundColor: "white",
                boxShadow: 1,
              }}
            >
              <ArrowForwardIosIcon fontSize="small" />
            </IconButton>
          </Box> */}
        </Box>

        {/* Shop cards grid with 2 cards per row and proper spacing */}
        <Grid container spacing={4}>
          {visibleShops.map((shop) => (
            <Grid item xs={12} sm={3} key={shop.id}>
              <ShopCard shop={shop} />
            </Grid>
          ))}
        </Grid>
      </Container>
      <UserFooter />
      <ScrollToTopButton />
    </>
  );
};

export default SeeallnearbyShopsSection;
